import Echo from 'laravel-echo';
import { broadcastClientConfig } from '@/shared/config/broadcast';
import { Auth } from '@/shared/lib/auth';

// Echo передає auth.headers на сервер при кожній підписці на приватний канал
// (і повторно після реконекту сокета), тому токен обчислюємо в момент підписки,
// а не фіксуємо при завантаженні модуля: після повторного входу в іншій вкладці
// кабінет має підписуватись уже з актуальним токеном. Токен іншого акаунта
// Auth.token не віддає, тож підписки не перейдуть до чужого користувача.
const authHeaders = {
  get Authorization() {
    const token = Auth.token();
    return token ? `Bearer ${token}` : undefined;
  },
};

const BroadcastClient = new Echo({
  broadcaster: broadcastClientConfig.broadcaster,
  host: `${broadcastClientConfig.host}`,
  encrypted: broadcastClientConfig.encrypted,
  client: broadcastClientConfig.client,
  auth: {
    headers: authHeaders,
  },
});

export default BroadcastClient;
